import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { IconClose } from '@redteclab/icons'

import { Button } from 'base-ui'

type MarketplacePartnerRegisterPageAutocompleteChipProps = {
  label: string
  onRemove: () => void
}

export const MarketplacePartnerRegisterPageAutocompleteChip: FC<
  MarketplacePartnerRegisterPageAutocompleteChipProps
> = ({ label, onRemove }) => {
  const intl = useIntl()

  return (
    <div className="inline-flex items-center gap-2 rounded-full bg-light-brand-low px-3 py-2 text-dark-primary-max">
      <span>{label}</span>
      <Button
        aria-label={intl.formatMessage(
          {
            id: 'marketplacePartnerRegisterPage.brands.autocomplete.removeChip',
          },
          { label },
        )}
        className="relative"
        endIcon={
          <span className="relative block">
            <IconClose className="size-4 text-dark-primary-max hover:text-dark-hover-brand" />
            <span
              // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
              className="pointer-events-none absolute inset-[-8px]"
            />
          </span>
        }
        onClick={onRemove}
        size="large"
        variant="text"
      />
    </div>
  )
}
